exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media \nonly screen and (max-width: 675px) {\n    span{\n        font-size: 15px !important;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/spinner/spinner.component.css
// module id = ../../../../../src/app/shared/components/spinner/spinner.component.css
// module chunks = main